<div class="container-fluid py-5">
  <div class="text-center mb-5">
    <h2 class="fw-bold text-gradient">✨ Feedback Details</h2>
    <p class="text-muted">Manage user feedback visibility with ease</p>
  </div>

  <div class="card glass-card border-0 shadow-lg rounded-4 p-3">
    <div class="table-responsive table-scroll-wrapper">
      <table class="table table-hover align-middle mb-0">
        <thead class="text-white table-header">
          <tr>
            <th class="text-center">#</th>
            <th class="text-center">Name</th>
            <th class="text-center">Phone</th>
            <th class="text-center">Feedback</th>
            <th class="text-center">City</th>
            <th class="text-center">Email</th>
            <th class="text-center">Content Visibility</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let feedback of feedbacks; let i = index" class="bg-white bg-opacity-75 table-row">
            <td class="fw-bold text-center">{{ i + 1 }}</td>
            <td class="text-center">{{ feedback.name }}</td>
            <td class="text-center">{{ feedback.phone }}</td>
            <td class="text-wrap text-break text-center" style="max-width: 250px;">
              {{ feedback.feedbackContent }}
            </td>
            <td class="text-center">{{ feedback.city }}</td>
            <td class="text-center">{{ feedback.email }}</td>
            <td class="text-center">
              <div class="d-flex justify-content-center align-items-center gap-2">
                <select [(ngModel)]="feedback.contentShow"
                        class="form-select form-select-sm stylish-select">
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
                <button class="btn btn-success btn-sm stylish-btn"
                        (click)="updateContentShow(feedback)">
                  Submit
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>